import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { Key_enrollmentDocuments, Key_enrollments } from "../utils/constants";
import { getEnrollments } from "../services/school/student/getEnrollments";
import { getEnrollmentsDocuments } from "../services/school/student/getEnrollmentsDocuments";

export const useGetEnrollmentsQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_enrollments, JSON.stringify(data)],
    () => getEnrollments(data)
  );

  
export const useGetEnrollmentDocuments = (data: PagedRequestType) =>
  useQuery(
    [Key_enrollmentDocuments, JSON.stringify(data)],
    () => getEnrollmentsDocuments(data)
  );